import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const getMDTUsers = async () => {
  const token = getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getMDTUsers, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    }

  });

  return data;
};

const MDTusersService = { getMDTUsers };
export default MDTusersService;